module.exports = __webpack_public_path__ + "static/media/MrWalkerInterior.5f205cb6.jpg";